import { useState } from 'react';
/**Components */
import HeaderPage from '../../../components/page/header';
import BodyPage from '../../../components/page/body';
import ModalComponent from '../../../components/modal';
/** Componentes propios */
import Filter from './filter';
import FormProduct from './form';
/**Hooks */
import { useProducts } from '../../../hooks';
/**Models */
import { Product } from '../../../models';
/**Utilities */
import { SweetAlert } from '../../../utilities';

/** Modal Resource */
interface DataModalState {
  type: string;
  buttonSubmit: string | null;
  row: any | null;
  title: string | null;
  requirements: any[];
  onCloseModalForm: () => void;
  errosBackend: any;
}

export const ProductIndex = () => {
  const { fetchProducts, storeProduct, updateProduct, getRequirements, deleteProduct } = useProducts();
  const [dataModalResourceState, setDataModalResourceState] = useState<DataModalState>({
    type: '',
    buttonSubmit: null,
    row: null,
    title: null,
    requirements: [],
    onCloseModalForm: () => {},
    errosBackend: {},
  });
  const [errors, setErrors] = useState({});
  const [filterState, setFilterState] = useState({
    page: 1,
    category: '',
    brand: '',
    presentation: '',
    text: '',
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [stateModal, setStateModal] = useState<boolean>(false);

  const state = {
    page: {
      title: 'Productos',
      icon: 'ri-archive-2-line',
      model: 'products',
      header: {
        menu: ['Productos'],
      },
      buttons: {
        create: true,
        edit: true,
        destroy: true,
        import: false,
        export: false,
      },
    },
    dataTable: {
      body: {
        cols: [
          {
            name: 'code_internal',
            alias: 'Código',
            width: '8.5%',
          },
          {
            name: 'name',
            alias: 'Nombre',
          },
          {
            name: 'category_name',
            alias: 'Categoría',
          },
          {
            name: 'brand_name',
            alias: 'Marca',
          },
          {
            name: 'presentation_name',
            alias: 'Presentación',
          },
          {
            name: 'purchase_price',
            alias: 'Precio de compra',
            width: '12%',
          },
          {
            name: 'sale_price',
            alias: 'Precio de venta',
            width: '10%',
          },
          {
            name: 'state',
            alias: 'Estado',
            width: '7%',
            play: {
              type: 'states',
              values: {
                0: 'bg-danger-subtle text-danger',
                1: 'bg-success-subtle text-success',
              },
              names: {
                0: 'Inactivo',
                1: 'Activo',
              },
            },
          },
        ],
      },
    },
  };

  /** METODOS DEL FILTER */
  const onChangePage = (page: number, type: string) => {
    switch (type) {
      case 'prev':
        setFilterState({ ...filterState, page: filterState.page - 1 });
        fetchProducts(filterState.page - 1, filterState.category, filterState.brand, filterState.presentation, filterState.text, true);
        break;

      case 'current':
        setFilterState({ ...filterState, page: page });
        fetchProducts(page, filterState.category, filterState.brand, filterState.presentation, filterState.text, true);
        break;
      case 'next':
        setFilterState({ ...filterState, page: filterState.page + 1 });
        fetchProducts(filterState.page + 1, filterState.category, filterState.brand, filterState.presentation, filterState.text, true);
        break;
      default:
        break;
    }
  };
  const onClearFilters = () => {
    setFilterState({ ...filterState, category: '', brand: '', presentation: '', text: '' });
    fetchProducts(1, '', '', '', '', true);
  };

  const handleFilterChange = (newFilters: any) => {
    setFilterState(newFilters);
    fetchProducts(1, newFilters.category, newFilters.brand, newFilters.presentation, newFilters.text, false);
  };

  /** METODOS DE MODAL */
  const onCloseModalForm = () => {
    setStateModal(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setErrors({});
  };

  const onClickAddResource = (type: string) => {
    setDataModalResourceState({
      type: type,
      buttonSubmit: 'Registrar',
      row: null,
      title: 'Nuevo producto',
      requirements: getRequirements,
      onCloseModalForm: onCloseModalForm,
      errosBackend: {},
    });
    setStateModal(true);
    setIsModalOpen(true);
  };

  const onClickEditResource = (row: any) => {
    setDataModalResourceState({
      type: 'edit',
      buttonSubmit: 'Editar',
      row: row,
      title: 'Editar producto',
      requirements: getRequirements,
      onCloseModalForm: onCloseModalForm,
      errosBackend: {},
    });
    setStateModal(true);
    setIsModalOpen(true);
  };

  /** METODOS DEL FORM RESOURCE */
  const onSubmitForm = async (product: Product, type: string) => {
    switch (type) {
      case 'store':
        storeProduct(product)
          .then(() => {
            onCloseModalForm();
            SweetAlert.success('Mensaje', 'Producto registrado correctamente.');
          })
          .catch((error) => {
            setErrors(error.response.data.errors);
          });
        break;
      case 'edit':
        updateProduct(product)
          .then(() => {
            onCloseModalForm();
            SweetAlert.success('Mensaje', 'Producto actualizada correctamente.');
          })
          .catch((error) => {
            setErrors(error.response.data.errors);
          });
        break;
      default:
        break;
    }
  };

  const onClickButtonPersonalizado = () => {};
  const onClickDeleteResource = (row: any) => {
    SweetAlert.deleteConfirmation(
      () => handleDelete(row.id),
      handleCancelDelete,
      '¿Está seguro que desea eliminar el producto?',
      row.name,
    );
  };

  const handleDelete = (id: string) => {
    deleteProduct(id).then(() => {
      SweetAlert.success('Producto eliminado correctamente');
    });
  };
  const handleCancelDelete = () => {};

  return (
    <div className="main-body p-0">
      <div className="inner-wrapper">
        <div className="inner-main">
          <HeaderPage page={state.page} onModalResource={onClickAddResource} />
          <div className="inner-main-body">
            <div className="card card-featured card-featured-primary mb-3 mt-3">
              <div className="card-body">
                <Filter
                  requirements={getRequirements}
                  onClearFilters={onClearFilters}
                  filterState={filterState}
                  onFilterChange={handleFilterChange}
                />
                <BodyPage onChangeDelete={onClickDeleteResource} onClickButtonPersonalizado={onClickButtonPersonalizado} onChangeEdit={onClickEditResource} onChangePage={onChangePage} page={state.page} table={state.dataTable} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Resource */}
      {isModalOpen && (
        <ModalComponent
          stateModal={stateModal}
          typeModal={'static'}
          size={'modal-gg'}
          title={dataModalResourceState.title}
          content={<FormProduct errors={errors} data={dataModalResourceState} onSubmitForm={onSubmitForm} />}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default ProductIndex;
